export default {
  "s7": {
    "contactus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تواصل معنا"])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اتصل بنا"])},
    "contactustitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ابق على تواصل معنا"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء النقر أدناه للعثور على تفاصيل الاتصال الخاصة بنا"])}
  }
}